import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL!
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY!
const supabaseServiceKey = import.meta.env.VITE_SUPABASE_SERVICE_ROLE_KEY!

if (!supabaseUrl) {
  throw new Error("Missing environment variable: VITE_SUPABASE_URL");
}
if (!supabaseAnonKey) {
  throw new Error("Missing environment variable: VITE_SUPABASE_ANON_KEY");
}
if (!supabaseServiceKey) {
  throw new Error("Missing environment variable: VITE_SUPABASE_SERVICE_ROLE_KEY");
}

// Create a single instance of the Supabase client with proper session persistence
const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    storageKey: 'vestalist-auth-token',
    storage: window.localStorage,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
})

// Create admin client only when needed
// let adminClientInstance: ReturnType<typeof createClient> | null = null

// const getAdminClient = () => {
//   if (!adminClientInstance) {
//     adminClientInstance = createClient(supabaseUrl, supabaseServiceKey, {
//       auth: {
//         autoRefreshToken: false,
//         persistSession: false
//       }
//     })
//   }
//   return adminClientInstance
// }

export { supabase } 